import { createFileRoute } from '@tanstack/react-router';
import { IdentityValidation } from '../../components/access/identity-validation';

// Identity check for self-signup students. The AccessGate in `_app.tsx`
// renders this route WITHOUT the sidebar/navbar while the student is not yet
// validated, and bounces validated students on to the store.
export const Route = createFileRoute('/_app/validate')({
  component: IdentityValidation,
});
